export class PriceResumo {
  receitaBrutaSugerido = 0;
  receitaBrutaAdotado = 0;
  maoDeObraDiretaSugerido = 0;
  maoDeObraDiretaAdotado = 0;
  provisaoComercialSugerido = 0;
  provisaoComercialAdotado = 0;
  administrativoSugerido = 0;
  administrativoAdotado = 0;
  comissaoSugerido = 0;
  comissaoAdotado = 0;
  investimentoSugerido = 0;
  investimentoAdotado = 0;
  impostoSugerido = 0;
  impostoAdotado = 0;
  liderancaSugerido = 0;
  liderancaAdotado = 0;
  custosAdicionaisSugerido = 0;
  custosAdicionaisAdotado = 0;
  receitaLiquidaSugerido = 0;
  receitaLiquidaAdotado = 0;
  resultadoLiquidoSugerido = 0;
  resultadoLiquidoAdotado = 0;
  quantidadeHorasSugerido = 0;
  quantidadeHorasAdotado = 0;
  custoHoraMedioSugerido = 0;
  custoHoraMedioAdotado = 0;
  valorHoraMedioVendaSugerido = 0;
  valorHoraMedioVendaAdotado = 0;
  valorHoraMedioVendaSugeridoParceiro = 0;
  valorReceitaBrutaParceiro = 0;
  valorReceitaBrutaParceiroSugerido = 0;
  valorReceitaBrutaParceiroAdotado = 0;
  administrativoParceiroSugerido = 0;
  administrativoParceiroAdotado = 0;
  comissaoParceiroSugerido = 0;
  comissaoParceiroAdotado = 0;
  investimentoParceiroSugerido = 0;
  investimentoParceiroAdotado = 0;
  impostoParceiroSugerido = 0;
  impostoParceiroAdotado = 0;
  receitaLiquidaParceiroSugerido = 0;
  receitaLiquidaParceiroAdotado = 0;
  resultadoLiquidoParceiroSugerido = 0;
  resultadoLiquidoParceiroAdotado = 0;
  resultadoLiquidoTotalSugerido = 0;
  resultadoLiquidoTotalAdotado = 0;
  somaTotalCustoParceiroAdotado = 0;
  somaTotalCustoParceiroSugerido = 0;
}
